import { DynamicRoute } from '../../constants/routes';

export interface BreadcrumbRoute {
  title: DynamicRoute['title'];
  path: DynamicRoute['path'];
}

export const breadCrumbs = (routes: DynamicRoute[] | []): BreadcrumbRoute[] => {
  const crumbs = [
    {
      title: 'Home',
      path: '/',
    },
  ];

  routes
    .filter((route) => route.selected)
    .forEach((route) => {
      crumbs.push({
        title: route.title,
        path: route.path,
      });
    });

  return crumbs;
};
